/**
 * The Mapbox access token, which Vite inlines at build time.
 *
 * The suppression is not about the token's type: the project compiles with `--module commonjs`, under
 * which TypeScript rejects the `import.meta` meta-property outright (TS1343). Every other reader of
 * `import.meta.env` here carries the same line — this module is the one place the map components read it
 * from, so a second map does not add a second suppression.
 */
// @ts-ignore
export const MAPBOX_TOKEN: string | undefined = import.meta.env.VITE_MAPBOX_TOKEN;
